import React from "react";

import { PilotProgramTypes } from "../../../types/pilotProgram";
import { GatsbyImage } from "gatsby-plugin-image";

const PilotProgramBox = ({
  link,
  tag,
  id,
  light,
  image
}: PilotProgramTypes) => {
  return (
    <a
      href={link?.url || ""}
      target={link?.target || ""}
      className="a-pilotPrograms__carouselSlide"
      key={id}
    >
      <div
        className={`a-pilotPrograms__slideContent column-alignCenter space-between -gap15 ${
          light ? "-light" : ""
        }`}
      >
        {image && (
          <GatsbyImage
            image={image.gatsbyImageData}
            alt={image.alt || ""}
            className="a-pilotPrograms__slideImage"
          />
        )}
        <div className="a-pilotPrograms__slideLabel -title">{tag}</div>
      </div>
    </a>
  );
};

export default PilotProgramBox;
